// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { siteDomain } from '@trello/config';

import { FileLinkHandler } from 'app/scripts/views/internal/FileLinkHandler';
import { TrelloLinkHandler } from 'app/scripts/views/internal/TrelloLinkHandler';
import { shouldHandleClick } from 'app/scripts/views/internal/shouldHandleClick';

import Layout from 'app/scripts/views/lib/layout';
import { PopOver } from 'app/scripts/views/lib/pop-over';

export const handleLinkClick = (e: MouseEvent, elem: HTMLAnchorElement) => {
  const nonLinks = ['', '#', 'http://', 'http://#'];
  const href = elem.getAttribute('href');

  if (!href || nonLinks.includes(href)) {
    e?.preventDefault();
  } else if (href.startsWith('file://')) {
    FileLinkHandler(e, elem);
  } else if (href.startsWith('/') || href.startsWith(siteDomain + '/')) {
    TrelloLinkHandler(e, elem);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const globalClickHandler = (e: any) => {
  const $target = $(e.target);

  // This does a blanket selections for any classic fields using
  // 'editable-view.js' that are currently editing (as well as some other
  // selectors). We should aim to move this logic closer to the components that
  // need it (or into the editable-view).
  //
  // The giant if/else-if statement that used to live here would implicitly
  // ignore the Layout.isEditing() check for any clicks inside popovers. Removing
  // this check today causes any popovers that use the selectors checked for in
  // Layout.isEditing() to break (an example of this is the custom fields popover
  // that allows you to customize the options in a 'dropdown' custom field, where
  // you can no longer change the name of the option due to it being immediately
  // canceled without this check).
  //
  // Removal tracked in: FEPLAT-505
  const clickInPopover =
    PopOver.isVisible && $target.closest('.pop-over').length > 0;

  // This checks to see if the click event originated within an AtlasKit Editor
  // popup component (eg, text formatting dropdown) and if so, bypasses the
  // cancelEdits call.
  const clickInEditorPopup = $target.closest('[data-editor-popup]').length > 0;

  if (!clickInPopover && !clickInEditorPopup && Layout.isEditing()) {
    Layout.cancelEdits();
  }

  const $a = $target.closest('a');
  // If it's not a link or they're trying to do some fancy click (that opens in
  // a new tab, etc) don't try to subvert it
  if ($a.length && shouldHandleClick(e)) {
    handleLinkClick(e, $a[0]);
  }
};
